/* eslint-disable import/first */
const merge = require('webpack-merge')
// TODO 统一封装修改
// 小七当家
import * as api from './api'
// // 装修管理
// import * as zxgl from './zxgl/zxgl'

const result = merge(
  api
  // zxgl
)

export default result



// WEBPACK FOOTER //
// ./src/api/index.js